/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Producer_DeletedInputs */

const en_producer_deleted = /** @type {(inputs: Producer_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producer deleted`)
};

const es_producer_deleted = /** @type {(inputs: Producer_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productor eliminado`)
};

/**
* | output |
* | --- |
* | "Producer deleted" |
*
* @param {Producer_DeletedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const producer_deleted = /** @type {((inputs?: Producer_DeletedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Producer_DeletedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_producer_deleted(inputs)
	return es_producer_deleted(inputs)
});